import script from "./EditGalery.vue?vue&type=script&setup=true&lang=js"
export * from "./EditGalery.vue?vue&type=script&setup=true&lang=js"

import "./EditGalery.vue?vue&type=style&index=0&id=02110bb0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02110bb0"]])

export default __exports__